import { SimpleEntityGridActionCellButton } from "src/app/components/grid/CellRenderer/SimpleEntityGridActionCell/SimpleEntityGridActionCell";
import { UserRole } from "src/app/transports/user";
import { Order, WritingType } from "src/app/types/orders/order";
import { UserModel } from "src/app/types/UserModel";

export default function useWriteGridActions(currentUser: UserModel) {
    const actions: SimpleEntityGridActionCellButton[] = [];

    if (
        currentUser.role == UserRole.ROLE_ADMIN ||
        currentUser.role == UserRole.ROLE_PROJECT_MANAGER ||
        currentUser.role == UserRole.ROLE_LEAD_PROJECT_MANAGER ||
        currentUser.role == UserRole.ROLE_BUSINESS_MANAGER ||
        currentUser.role == UserRole.ROLE_LEAD_BUSINESS_MANAGER
    ) {
        actions.push("edit");
        actions.push("disable");
    }
    if (
        currentUser.role == UserRole.ROLE_ADMIN ||
        currentUser.role == UserRole.ROLE_WRITER ||
        currentUser.role == UserRole.ROLE_LEAD_WRITER ||
        currentUser.role == UserRole.ROLE_PROJECT_MANAGER ||
        currentUser.role == UserRole.ROLE_LEAD_PROJECT_MANAGER
    ) {
        actions.push("sendText");
    }
    actions.push("AIGuide");

    const AIGuideCondition = (data: Order): boolean => {
        return (
            data.content?.writingType === WritingType.AI_MANUAL &&
            !!data.keywords &&
            data.keywords.length > 0
        );
    };
    return { actions, AIGuideCondition };
}
